module.exports = __webpack_public_path__ + "static/media/writer@3x.196bcde0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tutorial/writer@3x.png
// module id = 742
// module chunks = 0